//
// Generated class PurchaseInvoiceLedgerAccountBalance
//

/// <reference path="PurchaseInvoiceLedgerAccountBalance_ManagedObject.ts" />

class PurchaseInvoiceLedgerAccountBalance extends PurchaseInvoiceLedgerAccountBalance_ManagedObject
{

}
